import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { PacoteCampanhaSituacaoModule } from '../situacao';
import { AreaMultiselectModule } from '../../../areas/components/multiselect';
import { TipoPromocaoCampanhaModule } from '../../promocao/tipo';

import { PacoteCampanhaFilterComponent } from './pacote-campanha-filter.component';

@NgModule({
    imports: [
        SharedModule,
        PacoteCampanhaSituacaoModule,
        AreaMultiselectModule,
        TipoPromocaoCampanhaModule
    ],
    declarations: [
        PacoteCampanhaFilterComponent
    ],
    exports: [
        PacoteCampanhaFilterComponent
    ]
})
export class PacoteCampanhaFilterModule { }
